import HTTP from './HTTP.js';
import SymfonyErrorFormatter from './SymfonyErrorFormatter';

class ClientServices {
    static getClients(status, include, limit = -1, cursor = 0, filters = {}) {
        return HTTP.get(`clients`,{
            params: {
                status: status,
                include: include,
                limit,
                cursor,
                filters
            }
        })
            .then((response) => {
                return {
                    data: response.data.clients,
                    meta: response.data.meta
                }
            }).catch(() => {
                return Promise.reject('Could not get End Point');
        });
    }

    static getClient(clientId, includes) {
        return HTTP.get(`clients/${clientId}`, {
            params: {
                include: includes
            }
        })
            .then((response) => {
                return response.data;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }
    
    static getLogoSubdomain(subdomain){
        return HTTP.get(`clients/logo/${subdomain}`)
            .then((response) => {
                return response;
            }).catch(() => {
                return Promise.reject('Could not get End Point');
            });
    }

    static updateClient(client) {
        return HTTP.post(`clients/${client.id}`, client)
            .then((response) => {
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static updateAgency(client,agency) {
        return HTTP.post(`clients/${client.id}/agency/${agency.id}`)
            .then((response) => {
                return response;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static createClient(client) {
        client.status = 'published';
        return HTTP.post(`clients`, client)
            .then((response) => {
                // Transformer needs to include address by default;
                return response.data;
            }).catch(error => {
                return SymfonyErrorFormatter.clean(error.response);
            });
    }

    static getClientDisplayConfig(clientId, includes) {
        return HTTP.get(`clients/${clientId}/display-config`, {
            params: {
                include: includes
            }
        })
        .then((response) => {
            return response.data;
        }).catch(error => {
            return SymfonyErrorFormatter.clean(error.response);
        });
    }
}

export default ClientServices;
